import { gql } from '@apollo/client';

export const OBJECTIVE_CRITERIA_QUERY = gql`
    query {
        objectiveCriteria {
            edges {
                node {
                    objectiveId
                    criterionTypeId
                    targetCount
                    targetValue
                    weight
                    isEnabled
                }
            }
        }
    }
`;
